<template>
  <div class="swiper-body">
    <div class="content">
      <img class="img" src="../../assets/swipper-2.png">
      <!-- <swiper class="swiper" ref="mySwiper" :options="swiperOptions">
        <swiper-slide class="swiper-item">
          <img class="img" src="../../assets/swipper-1.png">
        </swiper-slide>

        <swiper-slide class="swiper-item">
          <img class="img" src="../../assets/swipper-2.png">
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper> -->
    </div>
  </div>
</template>

<script>
import 'swiper/css/swiper.css'
import { Swiper, SwiperSlide,directive } from 'vue-awesome-swiper'

export default {
  components:{
    Swiper,
    SwiperSlide
  },
  directives: {
    swiper: directive
  },
  data() {
    return {
      swiperOptions: {
        pagination: {
          el: '.swiper-pagination',
          bulletClass : 'my-bullet',
          bulletActiveClass: 'my-bullet-active',
          clickable:true,
        },
        speed:2000,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false
        },
        // loop:true,
      }
    }
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper
    }
  },
  mounted() {
    // this.swiper.slideTo(3, 1000, false)
  },
  methods: {}
}
</script>

<style lang="less">
.my-bullet{
  width: 15px;
  height: 15px;
  display: inline-block;
  margin: 0 4px;
  border-radius: 100%;
  border: 1px solid #6B9BD1;
  &:hover{
    cursor: pointer;
  }
}
.my-bullet-active{
  background: #6B9BD1;
}
</style>
<style scoped lang="less">
.swiper-body{
  height: 800px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  .content{
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    justify-content: center;
    .img{
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
    .swiper{
      width: 100%;
      height: 100%;
      .swiper-item{
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: row;
        .img{
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
    }
  }
}

</style>


// WEBPACK FOOTER //
// src/components/index/e-swiper.vue